import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M11 .3a2.2 2.2 0 0 0-2.199 2.2v6.23h-6.23a2.2 2.2 0 0 0 0 4.398H8.8v6.23a2.2 2.2 0 0 0 4.398 0v-6.23h6.231a2.2 2.2 0 0 0 0-4.398H13.2V2.5A2.2 2.2 0 0 0 11 .3Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }